export const FEATURE_FLAG = {
  OPERATIONS: false,
  /**
   * Automatically refresh calendar data nad notifications?
   * Currently this should only be used for testing purposes
   */
  AUTO_REFRESH_DATA: true, // TODO: Remove feature flag

  /**
   * @see https://gitlab.dev.innovation-agents.de/ia/pro-musik/organisation/-/issues/295
   */
  SEND_COPY_TO_ME: true,

  /**
   * @see https://gitlab.dev.innovation-agents.de/ia/pro-musik/organisation/-/issues/71
   */
  SHOW_NOTE_UPDATE_MULTIPLE_ALLOCATIONS: true,
}

console.table(FEATURE_FLAG)
